module.exports = __webpack_public_path__ + "img/gfuel.5c922ba1.png";